/**
 * LineOfSight — tile-stepping raycast to check if a wall blocks
 * the line between two pixel positions.
 * Uses Bresenham-style tile stepping (half-tile increments for accuracy).
 */

import { MAP_GRID } from '@/map/MapData';
import { TileType, TILE_SIZE } from '@/config/GameConfig';

/**
 * Returns true if a straight line from (ax,ay) to (bx,by) is NOT blocked by a WALL tile.
 * Half-tile steps ensure we don't skip thin walls.
 */
export function hasLineOfSight(ax: number, ay: number, bx: number, by: number): boolean {
  const dx = bx - ax;
  const dy = by - ay;
  const dist = Math.sqrt(dx * dx + dy * dy);
  if (dist < 1) return true;

  const stepSize = TILE_SIZE * 0.5;
  const steps = Math.ceil(dist / stepSize);
  const sx = dx / steps;
  const sy = dy / steps;

  for (let i = 1; i < steps; i++) {
    const px = ax + sx * i;
    const py = ay + sy * i;
    const col = Math.floor(px / TILE_SIZE);
    const row = Math.floor(py / TILE_SIZE);
    const tile = MAP_GRID[row]?.[col];
    if (tile === TileType.WALL || tile === undefined) return false;
  }
  return true;
}
